import React, { FC, ReactElement, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import routes from '../../../config/routes'
import { useSelector } from 'react-redux'
import { getIsLoggedIn, getIsRegistrationRequired } from '../../../stores/reducers/userData'
import Icon from '../../Icon'
import EmployeeInfo from './EmployeeInfo/EmployeeInfo'
import QuestionModal from '../../Modals/QuestionModal/QuestionModal'
import EmployeeData from './employeeData'
import './questions.sass'

export interface EmployeeInfoObject {
  name: string
  post: string
  photo: string
}

interface EmployeeInfoProps {
  EmployeeInfo: EmployeeInfoObject
}

const reduceSpeakersByName = (speakers: any): any => {
  const sortedSpeakersByName = [...speakers]
  sortedSpeakersByName.sort((a, b) => {
    if(a.name < b.name) {
      return -1
    } else if(a.name > b.name) {
      return 1
    } else {
      return 0
    }
  })
  const reduced = sortedSpeakersByName.reduce((acc: any, item: EmployeeInfoObject): any => {
    const firstLetter: string = item.name.charAt(0)
    if (firstLetter in acc === false) {
      acc[firstLetter] = []
      acc[firstLetter].push(item)
    } else {
      acc[firstLetter].push(item)
    }
    return acc
  }, {})
  return reduced
}

const QuestionsPage: FC = (): ReactElement => {
  const history = useHistory()
  const isLoggedIn = useSelector(getIsLoggedIn)
  const isRegistrationRequired = useSelector(getIsRegistrationRequired)

  if (!isLoggedIn && isRegistrationRequired) history.push(routes.REGISTER)

  const [ isLoaded, setIsLoaded ]: any = useState<boolean>(false)
  const [ searchQuery, setSearchQuery ]: any = useState<string>('')
  const [ employees, setEmployees ]: any = useState<Array<any>>([])
  const [ isModalOpen, setIsModalOpen ] = useState<boolean>(false)
  const [ modalSubtitle, setModalSubtitle ] = useState<string>('')

  useEffect(() => {
    const filtered = EmployeeData.filter((employee: EmployeeInfoObject): any => employee.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1)
    const reducedEmployees = reduceSpeakersByName(filtered)
    setEmployees(reducedEmployees)
    setIsLoaded(true)
  }, [searchQuery])

  const openModalQuestions = (subtitle?: any): void => {
    setModalSubtitle(subtitle)
    setIsModalOpen(true)
  }

  const updateSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  if (!isLoggedIn && !isRegistrationRequired) {
    return (
      <>
      <div className="questions__header">
        <div className="container">
          <div className="container-back mb-8">
            <button className="button-back text-white" type="button" onClick={() => history.go(-1)}>
              <span className="button-icon"><Icon name="ch-arr-left" /></span>
              <span className="button-title">Назад</span>
            </button>
          </div>
          <h1>Для данного мероприятия вы не можете задать вопрос</h1>
        </div>
      </div>
      <section className="inner-section questions">
        <div className="container"></div>
      </section>
      </>
    )
  }

  return (
    <>
      <div className="questions__header">
        <div className="container">
          <div className="container-back mb-8">
            <button className="button-back text-white" type="button" onClick={() => history.go(-1)}>
              <span className="button-icon"><Icon name="ch-arr-left" /></span>
              <span className="button-title">Назад</span>
            </button>
          </div>
          <h1>Задай вопрос</h1>
        </div>
      </div>

      <section className="inner-section questions">
        <div className="container">
          <div className="questions__actions flex flex-column">
            <div className="wrapper-input col-5 mb-16">
              <input
                className="ui-input"
                type="text"
                value={searchQuery}
                onChange={updateSearchQuery}
                placeholder="Поиск"
              />
            </div>

            <div className="flex flex-column justify-start items-start">
              {/* <h4 className="m-0">Пресс-служба Intel. Есть вопрос?</h4> */}
              <button
                className="btn btn-primary btn--mobile-min bg-header question-to-press mt-16"
                onClick={() => openModalQuestions('пресс-службе')}
              >
                <span className="btn-subtitle">Пресс-служба</span>
                <span className="btn-title">Есть вопрос?</span>
              </button>
            </div>
          </div>

          {isLoaded ?
              <div className="questions__employees">
              {
                Object.keys(employees).length ?
                  Object.entries(employees).map(([key, item]: any) => (
                    <div key={key}>
                      <p className="questions__employees__firstletter">{key}</p>
                      <div className="questions__employees__row">
                        {item.map((employee: EmployeeInfoObject, index: number): any => (<EmployeeInfo employeeInfo={employee} openQuestionModal={openModalQuestions} key={index}/>))}
                      </div>
                    </div>
                  ))
                :
                  'Совпадений не найдено'
              }
            </div>
          :
            <div className=""></div>
          }
        </div>
        <QuestionModal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          recepient={modalSubtitle ? modalSubtitle : ''}
        />
      </section>
    </>
  )
}

export default QuestionsPage
